// components/TreatmentSummaryCard.tsx
import React, { CSSProperties } from 'react';
import { cancelButton, confirmButton } from '../../../components/Buttons';
import { MildSectionKey } from '../utils/asthmaTypes';

interface TreatmentSummaryCardProps {
  isEmailSent: boolean;
  isLoggedIn: boolean;
  onSendEmailClick: () => void;
  onCloseTreatmentClick: () => void;
  onBackToRecommendations: (section: MildSectionKey) => void;
  secondRoundStarted: boolean;
  thirdRoundStarted: boolean;
}

export const TreatmentSummaryCard: React.FC<TreatmentSummaryCardProps> = ({
  isEmailSent,
  isLoggedIn,
  onSendEmailClick,
  onCloseTreatmentClick,
  onBackToRecommendations,
  secondRoundStarted,
  thirdRoundStarted
}) => {

  // logic for where to return when clicking "back to recommendations"
  const targetRecommendationSection: MildSectionKey = thirdRoundStarted
    ? 'RECOMMENDATIONS_3'
    : secondRoundStarted
      ? 'RECOMMENDATIONS_2'
      : 'RECOMMENDATIONS';

  return (
    <div className="treatment-card summary-card">
      <div className="summary-actions">

        {/* send email button */}
        <button
          type="button"
          style={{
            ...(cancelButton as CSSProperties),
            ...(isEmailSent ? { opacity: 0.6, cursor: 'default' } : {})
          }}
          onClick={() => !isEmailSent && onSendEmailClick()}
        >
          {isEmailSent ? 'המייל נשלח ✓' : 'שליחה למייל'}
        </button>

        {/* close treatment button */}
        <button
          type="button"
          style={confirmButton as CSSProperties}
          onClick={onCloseTreatmentClick}
        >
          סגירת טיפול
        </button>
      </div>

      <button
        type="button"
        className="summary-back-link"
        onClick={() => onBackToRecommendations(targetRecommendationSection)}
      >
        חזרה להמלצות להמשך טיפול
      </button>
    </div>
  );
};